export default "__VITE_ASSET__BfBaoH0S__"